(function () {
  'use strict';

  var html = document.documentElement;

  /* ---------- Language navigation ---------- */
  var langToggle = document.getElementById('langToggle');
  if (langToggle) {
    var languageUrl = langToggle.getAttribute('data-language-url');
    if (languageUrl) {
      langToggle.addEventListener('click', function () {
        window.location.assign(languageUrl);
      });
    }
  }

  /* ---------- Theme toggle ---------- */
  var themeToggle = document.getElementById('themeToggle');
  var sunIcon = document.getElementById('themeIconSun');
  var moonIcon = document.getElementById('themeIconMoon');
  var prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  var currentTheme = prefersDark ? 'dark' : 'light';

  function applyTheme(theme) {
    html.setAttribute('data-theme', theme);
    sunIcon.style.display = theme === 'dark' ? 'none' : 'block';
    moonIcon.style.display = theme === 'dark' ? 'block' : 'none';
  }
  applyTheme(currentTheme);
  themeToggle.addEventListener('click', function () {
    currentTheme = currentTheme === 'dark' ? 'light' : 'dark';
    applyTheme(currentTheme);
  });

  /* ---------- Header scroll behavior ---------- */
  var header = document.getElementById('siteHeader');
  var lastScroll = 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 8);
    if (y > lastScroll && y > 160) {
      header.classList.add('is-hidden');
    } else {
      header.classList.remove('is-hidden');
    }
    lastScroll = y;
  }, { passive: true });

  /* ---------- Smooth in-page nav ---------- */
  document.querySelectorAll('[data-scroll]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var targetId = link.getAttribute('href');
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---------- Hero video ---------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heroVideo = document.getElementById('heroVideo');
  var heroFallbackImg = document.getElementById('heroFallbackImg');
  if (heroVideo) {
    if (reduceMotion) {
      heroVideo.pause();
      heroVideo.style.display = 'none';
      if (heroFallbackImg) heroFallbackImg.style.display = 'block';
    } else {
      heroVideo.addEventListener('error', function () {
        heroVideo.style.display = 'none';
        if (heroFallbackImg) heroFallbackImg.style.display = 'block';
      });
      var playPromise = heroVideo.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {
          heroVideo.style.display = 'none';
          if (heroFallbackImg) heroFallbackImg.style.display = 'block';
        });
      }
    }
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }

})();
